import angular from "angular";

angular.module('ui-sentinel.devices.devicePivot', [
    'ui-sentinel.devices'
]);
